import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCompany } from "../../context/companyContext";
import "../../pages/landing/LandingPageNew.css";

const TopBar = ({ theme }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { companyData } = useCompany();
  const location = useLocation();

  // Check if we're on the landing page
  const isLandingPage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Smooth scroll to section with offset for fixed navbar
  const scrollToSection = useCallback((e, sectionId) => {
    e.preventDefault();
    const id = sectionId.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      const navbarHeight = 80;
      const y = el.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      window.scrollTo({ top: y, behavior: "smooth" });
      window.history.pushState(null, "", sectionId);
    }
  }, []);

  const navLinks = [
    { label: "Home", href: "#hero" },
    { label: "Features", href: "#features" },
    { label: "How it Works", href: "#how-it-works" },
    { label: "Why-us", href: "#why-us" },
    { label: "Pricing", href: "#pricing" },
    { label: "Guide Tour", to: "/guide" },
  ];

  return (
    <>
      <nav className={`navbar-new ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo">
            <img
              src={
                theme === "light"
                  ? companyData.companyLogo || "/horizontal-transparent-light.png"
                  : companyData.companyLogo || "/horizontal-transparent-dark.png"
              }
              alt={`${companyData.companyName || "MessageOS"} Logo`}
            />
          </Link>

          <ul className="navbar-links">
            {navLinks.map((link) => (
              <li key={link.to || link.href}>
                {link.to ? (
                  <Link to={link.to}>{link.label}</Link>
                ) : isLandingPage ? (
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link to={`/${link.href}`}>{link.label}</Link>
                )}
              </li>
            ))}
          </ul>

          <div className="navbar-actions">
            {/* To restore the landing page theme switcher later, uncomment the button below.
            {toggleTheme && (
              <button
                className="theme-toggle"
                onClick={toggleTheme}
                aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
                title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
                type="button"
              >
                {theme === "dark" ? "☀️" : "🌙"}
              </button>
            )}
            */}
            <Link to="/login" className="btn-primary navbar-cta">
              Get Started
            </Link>
            <button
              className={`mobile-menu-btn ${mobileOpen ? "active" : ""}`}
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>

      <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
        <ul>
          {navLinks.map((link) => (
            <li key={link.to || link.href}>
              {link.to ? (
                <Link to={link.to} onClick={() => setMobileOpen(false)}>
                  {link.label}
                </Link>
              ) : isLandingPage ? (
                <a
                  href={link.href}
                  onClick={(e) => {
                    scrollToSection(e, link.href);
                    setMobileOpen(false);
                  }}
                >
                  {link.label}
                </a>
              ) : (
                <Link to={`/${link.href}`} onClick={() => setMobileOpen(false)}>
                  {link.label}
                </Link>
              )}
            </li>
          ))}
          <li>
            <Link to="/login" onClick={() => setMobileOpen(false)}>
              Get Started
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default TopBar;
